import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatchState, Match } from '../shared/model/match';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-create-matches-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule],
  templateUrl: './create-matches-component.html',
  styleUrl: './create-matches-component.scss'
})
export class CreateMatchesComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<CreateMatchesComponent>);
  private fb = inject(FormBuilder);
  private data = inject(MAT_DIALOG_DATA);

  private openSquashService = inject(OpenSquashService);

  form: FormGroup = this.fb.group({
    date: [new Date()],
    time: [''], // tipo 'HH:mm'
  });
  category: any;
  groupName: any;
  playersInGroup: any;

  ngOnInit(): void {
    this.category = this.data?.categoryType ?? 'sin-categoría';
    this.groupName = this.data?.groupName ?? 'sin-grupo';
    this.playersInGroup = this.data?.playersInGroup || [];
  }

  submit() {
    if (!this.form.valid) {
      return;
    }

    const valueForm = this.form.value;
    const date = new Date(valueForm.date);
    if (valueForm.time) {
      const [hours, minutes] = valueForm.time.split(':');
      date.setHours(+hours, +minutes, 0);
    } else{
      date.setHours(0, 0, 0);
    }

    // Obtener el primer caracter en mayúscula de category y groupName
    const categoryInitial = this.category?.charAt(0).toUpperCase() || '';
    const groupInitial = this.groupName?.charAt(0).toUpperCase() || '';

    // Generar todos los partidos posibles entre jugadores del grupo
    const matches: Match[] = [];
    
    for (let i = 0; i < this.playersInGroup.length; i++) {
      for (let j = i + 1; j < this.playersInGroup.length; j++) {
        const player1 = this.playersInGroup[i];
        const player2 = this.playersInGroup[j];
        
        const match = {
          code: `P${categoryInitial}${groupInitial}-${player1.playerId}-${player2.playerId}`,
          tournamentId: this.openSquashService.tournamentId,
          category: this.category,
          groupName: this.groupName,
          date: new Date(date), // Crear nueva instancia para cada partido
          player1Id: player1.playerId,
          player2Id: player2.playerId,
          court: 'Por definir',
          state: MatchState.PROGRAMADO
        } as Match;
        
        matches.push(match);
      }
    }

    // Crear todos los partidos
    let createdMatches = 0;
    const totalMatches = matches.length;
    
    matches.forEach((match, index) => {
      this.openSquashService.createMatch(match).subscribe({
        next: (createdMatch) => {
          createdMatches++;
          console.log(`Partido ${createdMatches}/${totalMatches} creado: ${createdMatch.code}`);
          
          // Cerrar el diálogo cuando se hayan creado todos los partidos
          if (createdMatches === totalMatches) {
            this.dialogRef.close({
              success: true,
              matchesCreated: createdMatches,
              matches: matches
            });
          }
        },
        error: (error) => {
          console.error(`Error creando partido ${match.code}:`, error);
          createdMatches++;
          
          if (createdMatches === totalMatches) {
            this.dialogRef.close({
              success: false,
              matchesCreated: createdMatches - 1, // Restar el que falló
              error: 'Algunos partidos no se pudieron crear'
            });
          }
        }
      });
    });
  }

  exit() {
    this.dialogRef.close(null);
  }
}
